var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 6.5625V2.64038C15.3125 2.3502 15.1973 2.07231 14.9922 1.86689L13.4453 0.320264C13.2402 0.115186 12.962 0 12.6718 0H3.28125C2.67729 0 2.1875 0.489795 2.1875 1.09375V6.5625C0.979248 6.5625 0 7.54175 0 8.75V12.5781C0 12.8803 0.244727 13.125 0.546875 13.125H2.1875V16.4062C2.1875 17.0102 2.67729 17.5 3.28125 17.5H14.2188C14.8227 17.5 15.3125 17.0102 15.3125 16.4062V13.125H16.9531C17.2553 13.125 17.5 12.8803 17.5 12.5781V8.75C17.5 7.54175 16.5208 6.5625 15.3125 6.5625ZM13.125 15.3125H4.375V12.0312H13.125V15.3125ZM13.125 7.65625H4.375V2.1875H10.9375V3.82812C10.9375 4.13027 11.1822 4.375 11.4844 4.375H13.125V7.65625ZM14.7656 10.1172C14.3127 10.1172 13.9453 9.74976 13.9453 9.29688C13.9453 8.84365 14.3127 8.47656 14.7656 8.47656C15.2185 8.47656 15.5859 8.84365 15.5859 9.29688C15.5859 9.74976 15.2185 10.1172 14.7656 10.1172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardware);
export default __webpack_public_path__ + "static/media/Hardware.ea5ac56193629566eeaf6ad66bc764ca.svg";
export { ForwardRef as ReactComponent };